import React from "react";
import { Card, CardContent } from "../ui/card";
import { AlertTriangle, Shield, BarChart3 } from "lucide-react";
import {
  calculateInherentRisk,
  calculateResidualRisk,
  calculateRiskCoverage,
  formatRiskValue,
} from "../../lib/riskAnalytics";

const RiskStats = ({ risks }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Total Risks
              </p>
              <p className="text-2xl font-bold">{risks.length}</p>
            </div>
            <AlertTriangle className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Inherent Risk
              </p>
              <p className="text-2xl font-bold text-foreground">
                {formatRiskValue(calculateInherentRisk(risks))}
              </p>
            </div>
            <AlertTriangle className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Residual Risk
              </p>
              <p className="text-2xl font-bold text-foreground">
                {formatRiskValue(calculateResidualRisk(risks))}
              </p>
            </div>
            <Shield className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Coverage
              </p>
              <p className="text-2xl font-bold text-foreground">
                {calculateRiskCoverage(risks)}%
              </p>
            </div>
            <BarChart3 className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RiskStats;
